export const initialise = () => {
    if (!document.body.classList.contains('page-redesign')) return
    if (!document.body.classList.contains('page-jobs')) return
    const searchWidgets = document.querySelectorAll<HTMLDivElement>('.search-filters-widget')

    searchWidgets.forEach(searchWidget => {
        header(searchWidget)
        childLists(searchWidget)
        keyword(searchWidget)
        resize(searchWidget) 
        createClearLink(searchWidget)
        toggleLocationFilter(searchWidget)
    })
  
}

const header = (searchWidget: HTMLDivElement) => {
    const filterHeading = searchWidget.querySelector<HTMLDivElement>('#filter-header')
    if (!filterHeading) return

    const filterList = searchWidget.querySelector<HTMLDivElement>('.search-filters-widget__filter-list')
    if (!filterList) return
    filterList.setAttribute('aria-hidden', 'false')
    filterList.classList.add('search-filters-widget__filter-list--open')
    
    const button = document.createElement('button')
    button.className = 'search-filters-widget__heading-button'
    button.textContent = `{{js.widget.search-filters.heading}}`
    button.setAttribute('aria-expanded', 'true')

    button.addEventListener('click', () => {
        filterList.classList.toggle('search-filters-widget__filter-list--open')
        filterList.setAttribute('aria-hidden', filterList.classList.contains('search-filters-widget__filter-list--open') ? 'false' : 'true')
        button.setAttribute('aria-expanded', filterList.classList.contains('search-filters-widget__filter-list--open') ? 'true' : 'false')
        document.body.classList.toggle('nav-open')
    })

    filterHeading.appendChild(button)
}

const childLists = (searchWidget: HTMLDivElement) => {
    const optionFilters = searchWidget.querySelectorAll<HTMLDivElement>('.optionfiltergroup')

    optionFilters.forEach(filter => {
        const filterOptionsWithChildren = filter.querySelectorAll<HTMLDivElement>('.filter-option.has-child-elements')
        
        filterOptionsWithChildren.forEach(option => {
            const expandHide = option.querySelector<HTMLSpanElement>('.filter-expand-hide')
            const childList = option.querySelector<HTMLDivElement>('.child-list')
            if (!expandHide || !childList) return

            expandHide.setAttribute('role', 'button')
            expandHide.setAttribute('aria-expanded', 'false')
            childList.setAttribute('aria-hidden', 'true')

            expandHide.addEventListener('click', (e) => {
                e.stopPropagation()
                option.classList.toggle('filter-option--open')
                childList.setAttribute('aria-hidden', option.classList.contains('filter-option--open') ? 'false' : 'true')
                expandHide.setAttribute('aria-expanded', option.classList.contains('filter-option--open') ? 'true' : 'false')
            })
        })  
    })
}

const keyword = (searchWidget: HTMLDivElement) => {
    const keywordOptionWrapper = searchWidget.querySelector<HTMLDivElement>('#keyword-option-wrapper')
    if (!keywordOptionWrapper) return

    const container = document.querySelector<HTMLDivElement>('.page-jobs__jobs--top .container-col')
    if (!container) return

    container.appendChild(keywordOptionWrapper)
}

const resize = (searchWidget: HTMLDivElement) => {
    const mediaQuery = window.matchMedia('(min-width: 1200px)')
    const filterList = searchWidget.querySelector<HTMLDivElement>('.search-filters-widget__filter-list')
    if (!filterList) return

    const toggleFilterList = (e: MediaQueryListEvent | MediaQueryList) => {
        if (e.matches) {
            filterList.classList.add('search-filters-widget__filter-list--open')
            filterList.setAttribute('aria-hidden', 'false')
        } else {
            filterList.classList.remove('search-filters-widget__filter-list--open')
            filterList.setAttribute('aria-hidden', 'true')
        }
    }
    
    mediaQuery.addEventListener('change', toggleFilterList)
    toggleFilterList(mediaQuery)
    window.addEventListener('resize', () => toggleFilterList(mediaQuery))
}

const createClearLink = (searchWidget: HTMLDivElement) => {
    const container = searchWidget.querySelector<HTMLDivElement>('.search-filters-widget__filter-list')
    if (!container) return

    const clearLink: HTMLAnchorElement = document.createElement('a')
    clearLink.classList.add("search-filters-widget__clear-link", "attrax-button")
    clearLink.innerHTML = `{{js.widget.search-filters.clear-all}}`
    clearLink.href = "{{js.widget.search-filters.button.clear.href}}"
    container.appendChild(clearLink)
}

export const toggleLocationFilter = (searchWidget: HTMLDivElement) => {
    const locationFilter = searchWidget.querySelector<HTMLDivElement>('.location-filter')

    const locationFilterHeading = locationFilter?.querySelector<HTMLDivElement>('.header')

    if (!locationFilter || !locationFilterHeading) return

    locationFilterHeading.addEventListener('click', () => {
        locationFilter.classList.toggle('category-opened')
    })
};